import { render, staticRenderFns } from "./changeEmail.vue?vue&type=template&id=626e10dd&scoped=true"
import script from "./changeEmail.vue?vue&type=script&lang=js"
export * from "./changeEmail.vue?vue&type=script&lang=js"
import style0 from "./changeEmail.vue?vue&type=style&index=0&id=626e10dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e10dd",
  null
  
)

export default component.exports